import React, { useState } from 'react';
import { BookOpen, Search, ChevronDown, X, List, ArrowRight } from 'lucide-react';
import logo from '../Hy.C.png';
import Typewriter from "../components/Typewriter";

interface SubBook {
  id: string;
  title: string;
  subtitle: string;
  description: string;
  link: string;
  year: string;
  author: string;
  cover?: string;
}

interface Book {
  id: number;
  title: string;
  subtitle: string;
  cover: string;
  category: string;
  description: string;
  link?: string;
  year: string;
  author: string;
  subBooks?: SubBook[];
}

export default function Index() {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [selectedBook, setSelectedBook] = useState<Book | null>(null);
   const [selectedCollection, setSelectedCollection] = useState<Book | null>(null);
  const [selectedSubBook, setSelectedSubBook] = useState<SubBook | null>(null);

  const [showCategories, setShowCategories] = useState(false);

  const books: Book[] = [
    {
      id: 1,
      title: 'Next.js Full-Stack Development',
      subtitle: 'Deep Dive into React & Next.js',
      cover: 'https://hyc.eshachem.com/wp-content/uploads/2026/05/7F530727-694E-4797-8842-01D3550DE2EE-1-2048x1152.jpg',
      category: 'Full-Stack Development',
      description: 'JS and React from scratch, along with advanced Next.js app-router & server action techniques.',
      link: 'https://eminent-glider-8c3.notion.site/93b94cbf6abf4675a28850821a725f7b?pvs=74',
      year: '2024/7/5',
      author: 'Hung-Yu Chen'
    },
    {
      id: 7,
      title: 'Python: From 0 to Data Structures and Algorithms',
      subtitle: 'Data Structures and Algorithms - Python',
      cover: 'https://hyc.eshachem.com/wp-content/uploads/2026/05/FFABE4B9-5CC1-4AC7-A144-9E9ED8E66298-1536x1536.jpg',
      category: 'Programming Languages',
      description: 'From absolute basics to advanced algorithms, a comprehensive practical guide to competitive programming with Python.',
      link: 'https://hackmd.io/@HyC-1029/rJWp7au0bg/https%3A%2F%2Fhyc.eshachem.com',
      year: '2025/2/12',
      author: 'Hung-Yu Chen'
    },
    {
      id: 2,
      title: 'C++: From 0 to Data Structures and Algorithms',
      subtitle: 'Data Structures and Algorithms',
      cover: 'https://hyc.eshachem.com/wp-content/uploads/2026/05/S__29351968_0-1-768x432.jpg',
      category: 'Programming Languages',
      description: 'Competitive programming and common algorithms, a self-guided journey aimed at achieving APCS Practical Level 4.',
      link: 'https://hackmd.io/@HyC-1029/HyCpp/%2FzETIn-1fQaejxx_-exlh3A',
      year: '2025/2/6',
      author: 'Hung-Yu Chen'
    },
    {
      id: 3,
      title: 'JavaScript - Basic',
      subtitle: 'Deep Understanding of JS and Problem Solving with JS',
      cover: 'https://hyc.eshachem.com/wp-content/uploads/2026/05/LINE_ALBUM_%E7%B4%90%E8%A5%BF%E8%98%AD%E4%B9%8B%E6%97%85-%E4%B8%8D%E7%9F%A5%E9%81%93%E6%9C%89%E6%B2%92%E6%9C%89%E4%B8%8A%E5%82%B3%E9%81%8E-%E5%B0%B1%E6%94%BE%E5%9C%A8%E9%80%99_250830_1-1-768x432.jpg',
      category: 'Programming Languages',
      description: 'It is highly recommended to master JS before learning React.',
      link: 'https://eminent-glider-8c3.notion.site/JavaScript-Basic-12a9def5443d80488b9cf562ef3a3ccf?pvs=74',
      year: '2024/10/25',
      author: 'Hung-Yu Chen'
    },
    {
      id: 4,
      title: 'Backend Development',
      subtitle: 'SpringBoot Course Lecture Notes',
      cover: 'https://hyc.eshachem.com/wp-content/uploads/2026/05/S__29351976-768x432.jpg',
      category: 'Backend Development',
      description: 'A powerful and robust backend framework. These notes assume you already have a foundational knowledge of Java.',
      link: 'https://eminent-glider-8c3.notion.site/2c19def5443d8008ab47c963b63ec8a2?pvs=74',
      year: '2025/12/6',
      author: 'Hung-Yu Chen'
    },
    {
      id: 5,
      title: 'Django/Flask/MySQL',
      subtitle: 'Django/Flask/MySQL Course Lecture Notes',
      cover: 'https://hyc.eshachem.com/wp-content/uploads/2026/05/S__29351972_0-1-768x1365.jpg',
      category: 'Backend Development',
      description: 'For rapid prototyping and demos, a powerful framework and database are essential.',
      link: 'https://eminent-glider-8c3.notion.site/Django-Flask-MySQL-2b39def5443d80b9acfad70961d88589?pvs=74',
      year: '2025/6/15',
      author: 'Hung-Yu Chen'
    },
    {
      id: 6,
      title: 'JavaScript - HTML',
      subtitle: 'Specific JS Syntax and Applications in HTML',
      cover: 'https://hyc.eshachem.com/wp-content/uploads/2026/05/S__29351964_0-1-768x768.jpg',
      category: 'Frontend Development',
      description: 'Understanding how JS applies to HTML will help you better grasp how React works under the hood.',
      link: 'https://eminent-glider-8c3.notion.site/JavaScript-html-1649def5443d80c49f0ffd353e644602?pvs=74',
      year: '2024/12/22',
      author: 'Hung-Yu Chen'
    },
    {
      id: 7,
      title: 'High School Mathematics',
      subtitle: 'Digital Math A practice tests.',
      cover: 'https://hyc.eshachem.com/wp-content/uploads/2026/05/6D4640C2-5207-495E-A3F0-19CFA80B796E-768x768.jpg',
      category: 'Other Resources',
      description: 'Digital copies and handwritten detailed solutions for High School Math A practice tests.',
      link: 'https://eminent-glider-8c3.notion.site/3cb9def5443d804882e3e4e125207995?source=copy_link',
      year: '2026/8/29',
      author: 'Hung-Yu Chen'
    },
    {
      id: 9,
      title: 'Project Management & System Planning',
      subtitle: '',
      cover: 'https://hyc.eshachem.com/wp-content/uploads/2026/09/S__38961155.jpg',
      category: 'System & Management',
      description: 'Compiles my research notes and key findings from the literature and academic papers I have reviewed, focusing on Agile and the process from system analysis to software development.',
      year: '2026/8',
      author: 'Hung-Yu Chen',
      subBooks: [
        {
          id: 'sub-5',
          title: '系統分析與開發實踐手冊',
          subtitle: 'Handbook of Systems Analysis and Development Practices',
          description: 'This manual is intended for everyday software development, project implementation, and Hackathons, particularly in situations where system analysis and development must be completed rapidly within a limited timeframe. It provides concise, practical, and easily accessible content for quick reference and real-world application.',
          link: 'https://drive.google.com/file/d/1Ydo1BMm8vPtdD1-jp6bjrRC56NWs0Y8r/view',
          year: '2026/9/7',
          author: 'Hung-Yu Chen'
        },
        {
          id: 'sub-4',
          title: '五大敏捷因素:團隊雷達',
          subtitle: 'Evidence-Based Guidelines for Team Self-Organization and Reflection',
          description: 'This radar tool draws on the contemporary psychological framework of the “Big Five Personality Traits” and distills the mechanisms that influence the self-organization and resilience of Agile teams into five measurable core dimensions',
          link: 'https://drive.google.com/file/d/1K9_WcciCIQAuyksGoE1Tao56bPm8vMVZ/view',
          year: '2026/9/6',
          author: 'Hung-Yu Chen'
        },
        {
          id: 'sub-1',
          title: 'Scrum 敏捷框架入門',
          subtitle: 'Introduction to the Scrum Agile Framework',
          description: 'Scrum is the most popular and widely adopted incremental product development framework in today’s Agile methodology.',
          link: 'https://drive.google.com/file/d/1RWQWrpiI6vXqE8I12FObQE14uRpERt_P/view',
          year: '2026/9/4',
          author: 'Hung-Yu Chen'
        },
        {
          id: 'sub-2',
          title: '敏捷基礎導讀與實戰情境手冊',
          subtitle: 'Agile Foundation Guide and Practical Scenarios Handbook',
          description: 'Agile strongly advocates for cross-functional and collaborative teams, regarding open communication, teamwork, adaptability, and trust as the cornerstones of effective team operation.',
          link: 'https://drive.google.com/file/d/1du2aWK0tBSzIASqY3HpUZiynUBzqkWT4/view',
          year: '2026/9/4',
          author: 'Hung-Yu Chen'
        },
        {
          id: 'sub-3',
          title: 'Scrum@Scale (SaS) 框架實戰導讀指南',
          subtitle: 'A Practical Guide to Scrum@Scale (SaS) Framework Implementation',
          description: 'Establishing the Organizational Design, Dual-Track Mechanism, and Principles of Practice for an Agile Operating System (AOS).',
          link: 'https://drive.google.com/file/d/1UE53ii9eYO5G46RKMSzeKEEZHqO7D1DM/view',
          year: '2026/3/20',
          author: 'Hung-Yu Chen'
        },
        
        
      ]
    }
  ];

  const categories = ['All', ...Array.from(new Set(books.map(book => book.category)))];

  const filteredBooks = books.filter(book => {
    const matchesSearch = book.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                          book.subtitle.toLowerCase().includes(searchTerm.toLowerCase()) ||
                          book.author.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategory = selectedCategory === 'All' || book.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });
  
  const texts = [
    "Hello there! What did you have for lunch today?",
    "I'm Hung-Yu Chen, and welcome to my lecture notes and e-book reading room!",
    "I hope this repository helps you level up on your learning journey!",
    "If you have any questions, feel free to reach out and ask!"
  ];

  const handleBookClick = (book: Book) => {
    if (book.subBooks && book.subBooks.length > 0) {
      setSelectedCollection(book);
    } else {
      setSelectedBook(book);
    }
  };

  return (
    <div className="app">
      <header className="header">
        <div className="header-content">
            <a href='https://hyc.eshachem.com/'>
                <img src={logo} alt="logo" width={90}/> 
            </a>
          
            <h1>Reading Room</h1>
            <Typewriter texts={texts} />
        </div>
      </header>

      <div className="container">
        <div className="controls">
          <div className="search-section">
            <div className="search-bar">
              <Search size={18} strokeWidth={1.5} />
              <input
                type="text"
                placeholder="Search by title, author..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            <div className="category-dropdown">
              <button 
                className="dropdown-btn"
                onClick={() => setShowCategories(!showCategories)}
              >
                <span>{selectedCategory}</span>
                <ChevronDown size={18} strokeWidth={1.5} />
              </button>
              
              {showCategories && (
                <div className="dropdown-menu">
                  {categories.map(category => (
                    <button
                      key={category}
                      className={`dropdown-item ${selectedCategory === category ? 'active' : ''}`}
                      onClick={() => {
                        setSelectedCategory(category);
                        setShowCategories(false);
                      }}
                    >
                      {category}
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="books-grid">
          {filteredBooks.map(book => (
            <div 
              key={book.id} 
              className="book-item"
              onClick={() => handleBookClick(book)}
            >
              <div className="book-cover">
                <img src={book.cover} alt={book.title} />
              </div>
              <div className="book-info">
                <p className="book-category">{book.category}</p>
                <h3 className="book-title">{book.title}</h3>
                <p className="book-subtitle">{book.subtitle}</p>
              </div>
            </div>
          ))}
        </div>

        {filteredBooks.length === 0 && (
          <div className="no-results">
            <p>No relevant books found.</p>
          </div>
        )}
      </div>

      {/* 一般書籍的 Modal 詳情 */}
      {selectedBook && (
        <div className="modal-overlay" onClick={() => setSelectedBook(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={() => setSelectedBook(null)}>
              <X size={24} strokeWidth={1.5} />
            </button>
            <div className="modal-body">
              <div className="modal-cover">
                <img src={selectedBook.cover} alt={selectedBook.title} />
              </div>
              <div className="modal-details">
                <p className="modal-category">{selectedBook.category}</p>
                <h2 className="modal-title">{selectedBook.title}</h2>
                <p className="modal-subtitle">{selectedBook.subtitle}</p>
                <div className="modal-meta">
                  <span>Author: {selectedBook.author}</span>
                  <span>Start year: {selectedBook.year}</span>
                </div>
                <p className="modal-description" style={{ whiteSpace: "pre-line" }}>{selectedBook.description}</p>
                {selectedBook.link && (
                  <a 
                    href={selectedBook.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="read-link"
                  >
                    Start Reading
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* 專案管理與系統分析：點擊後展開的「條列式書籍列表」 Modal */}
      {selectedCollection && (
        <div className="modal-overlay" onClick={() => setSelectedCollection(null)}>
          <div className="modal-content collection-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '700px' }}>
            <button className="close-btn" onClick={() => setSelectedCollection(null)}>
              <X size={24} strokeWidth={1.5} />
            </button>
            <div className="modal-body" style={{ flexDirection: 'column', gap: '16px' }}>
              <div>
                <p className="modal-category">{selectedCollection.category}</p>
                <h2 className="modal-title" style={{ fontSize: '1.5rem', marginBottom: '4px' }}>{selectedCollection.title}</h2>
                <p className="modal-subtitle">{selectedCollection.subtitle}</p>
                <p className="modal-description" style={{ fontSize: '0.95rem' }}>{selectedCollection.description}</p>
              </div>

              <hr style={{ border: 'none', borderTop: '1px solid #eee', margin: '4px 0' }} />

              <h3 style={{ fontSize: '1.1rem', color: '#333', display: 'flex', alignItems: 'center', gap: '6px' }}>
                <List size={18} /> Book List
              </h3>

              <div className="sub-books-list" style={{ display: 'flex', flexDirection: 'column', gap: '10px', maxHeight: '279px', overflowY: 'auto', paddingRight: '4px' }}>
                {selectedCollection.subBooks?.map((sub, index) => (
                  <div 
                    key={sub.id} 
                    className="sub-item"
                    onClick={() => setSelectedSubBook(sub)}
                  >
                    <div style={{ flex: 1 }}>
                      <h4 style={{ fontSize: '1rem', color: '#111', marginBottom: '2px' }}>{sub.title}</h4>
                      <p style={{ fontSize: '0.85rem', color: '#666', margin: 0 }}>{sub.subtitle}</p>
                    </div>
                    <div style={{ display: 'flex', gap: '8px' }}>
                      <a 
                        href={sub.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="read-link"
                      >
                        Start Reading <ArrowRight size={14} />
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* 單一子書籍的詳細資訊 Modal（點擊 Details 時觸發） */}
      {selectedSubBook && (
        <div className="modal-overlay" onClick={() => setSelectedSubBook(null)} style={{ zIndex: 1100 }}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={() => setSelectedSubBook(null)}>
              <X size={24} strokeWidth={1.5} />
            </button>
            <div className="modal-body" style={{ flexDirection: 'column' }}>
              <div className="modal-details">
                <h2 className="modal-title">{selectedSubBook.title}</h2>
                <p className="modal-subtitle">{selectedSubBook.subtitle}</p>
                <div className="modal-meta">
                  <span>Author: {selectedSubBook.author}</span>
                  <span>Date: {selectedSubBook.year}</span>
                </div>
                <p className="modal-description" style={{ whiteSpace: "pre-line", marginTop: '12px' }}>{selectedSubBook.description}</p>
              </div>
            </div>
          </div>
        </div>
      )}

      <footer className="footer">
        <p>2025 Reading Room | Continuously Updated ©Hy.C CC BY-NC-SA 4.0
Non-Commercial Use Only | Attribution Required | ShareAlike under Same Terms</p>
      </footer>
    </div>
  );
};

const style = document.createElement('style');
style.textContent = `
@import url('https://fonts.googleapis.com/css2?family=Noto+Serif+TC:wght@300;400;500;600;700&display=swap');

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  &::-webkit-scrollbar {
    display: none;
  }

}

body {
  font-family: "Noto Serif TC", serif;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
  background: #131316 ;
  color: #FFFFFF;
  line-height: 1.8;
  min-height: 100vh;
}

body::before {
  content: '';
  position: fixed;
  inset: 0;
  background-image:
    repeating-linear-gradient(0deg, rgba(0,0,0,.06) 0, transparent 1px, transparent 9px),
    repeating-linear-gradient(90deg, rgba(0,0,0,.06) 0, transparent 1px, transparent 9px);
  background-size: 10px 10px; /* 每格大小 */
  pointer-events: none;
  z-index: 0;
  animation: matrix-rain 120s linear infinite;
}
  @keyframes matrix-rain {
  from {
    background-position: 0 0;
  }
  to {
    background-position: 0 1000px;
  }
}

.app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.header {
  background: #131316;
  backdrop-filter: blur(10px);
  padding: 2.5rem 2rem;
  text-align: center;
  border-bottom: 1px solid rgba(58, 54, 50, 0.1);
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;

  
}
.header-content img {
    weight:12px;
    background-color: #FFFFFF;
}


.header-content svg {
  color: #FFFFFF;
}

.header h1 {
  font-size: 3rem;
  font-weight: 500;
  color: #FFFFFF;
  letter-spacing: 0.3rem;
}

.subtitle {
  color: #6b6560;
  font-size: 0.875rem;
  font-weight: 300;
  letter-spacing: 0.2rem;
}

.container {
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  padding: 0 2rem;
  flex: 1;
}

.controls {
  margin-bottom: 3rem;
}

.search-section {
  display: flex;
  gap: 1rem;
  max-width: 600px;
  margin: 0 auto;
}

.search-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #fff ;
  border: 1px solid rgba(139, 115, 85, 0.2);
  border-radius: 0;
  padding: 0.875rem 1.25rem;
  flex: 1;
  transition: all 0.3s ease;
  z-index:10;
}

.search-bar:focus-within {
  border-color: rgba(139, 115, 85, 1);
  background: rgba(255, 255, 255, 0.95);
}

.search-bar svg {
  color: #8b7355;
  flex-shrink: 0;
}

.search-bar input {
  flex: 1;
//   background: transparent;
  border: none;
  color: #3a3632;
  font-size: 0.9rem;
  font-family: "Noto Serif TC", serif;
  outline: none;
}

.search-bar input::placeholder {
  color: #9b8f85;
}

.category-dropdown {
  position: relative;
}

.dropdown-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.875rem 1.25rem;
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid rgba(139, 115, 85, 0.2);
  color: #3a3632;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: "Noto Serif TC", serif;
  font-size: 0.9rem;
  white-space: nowrap;
}

.dropdown-btn:hover {
  background: rgba(255, 255, 255, 0.95);
  border-color: rgba(139, 115, 85, 0.4);
}

.dropdown-menu {
  position: absolute;
  top: calc(100% + 0.5rem);
  right: 0;
  background: rgba(255, 255, 255, 0.98);
  border: 1px solid rgba(139, 115, 85, 0.2);
  min-width: 180px;
  box-shadow: 0 8px 24px rgba(58, 54, 50, 0.1);
  z-index: 10;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: 0.75rem 1.25rem;
  background: transparent;
  border: none;
  color: #3a3632;
  text-align: left;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: "Noto Serif TC", serif;
  font-size: 0.9rem;
  border-bottom: 1px solid rgba(139, 115, 85, 0.1);
}

.dropdown-item:last-child {
  border-bottom: none;
}

.dropdown-item:hover {
  background: rgba(139, 115, 85, 0.05);
}

.dropdown-item.active {
  background: rgba(139, 115, 85, 0.1);
  color: #8b7355;
}

.books-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 2rem;
}

.book-item {
  cursor: pointer;
  transition: transform 0.3s ease;
}

.book-item:hover {
  transform: translateY(-4px);
}

.book-cover {
  width: 100%;
  aspect-ratio: 2/3;
  overflow: hidden;
  margin-bottom: 1rem;
  box-shadow: 0 4px 12px rgba(58, 54, 50, 0.15);
}

.book-cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.book-item:hover .book-cover img {
  transform: scale(1.05);
}

.book-info {
  text-align: center;
}

.book-category {
  font-size: 0.75rem;
  color: #8b7355;
  margin-bottom: 0.5rem;
  letter-spacing: 0.1rem;
  font-weight: 300;
}

.book-title {
  font-size: 1rem;
  font-weight: 500;
  color: #FFFFFF;
  margin-bottom: 0.25rem;
  letter-spacing: 0.05rem;
}

.book-subtitle {
  font-size: 0.8rem;
  color: #B6ACA4;
  font-weight: 300;
}

.no-results {
  text-align: center;
  padding: 4rem 2rem;
  color: #E6E6E6;
  font-size: 0.9rem;
}

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(58, 54, 50, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  padding: 2rem;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.modal-content {
  background: #E0E0E0;
  max-width: 800px;
  width: 100%;
  max-height: 90vh;
  overflow:scroll;
  position: relative;
  animation: slideUp 0.3s ease;
  box-shadow: 0 20px 60px rgba(58, 54, 50, 0.3);
}

@keyframes slideUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.close-btn {
  position: absolute;
  top: 1.5rem;
  right: 1.5rem;
  background: transparent;
  border: none;
  color: #3a3632;
  cursor: pointer;
  padding: 0.5rem;
  transition: all 0.3s ease;
  z-index: 10;
}

.close-btn:hover {
  color: #8b7355;
}

.modal-body {
  display: flex;
  gap: 2rem;
  padding: 2rem;
}

.modal-cover {
  width: 240px;
  height:100%;
  flex-shrink: 0;
}

.modal-cover img {
  width: 100%;
  height: 50vh;
  object-fit: cover;
  box-shadow: 0 8px 24px rgba(58, 54, 50, 0.2);
}

.modal-details {
  flex: 1;
  padding-top: 1rem;
}

.modal-category {
  font-size: 0.75rem;
  color: #8b7355;
  margin-bottom: 1rem;
  letter-spacing: 0.1rem;
  font-weight: 300;
}

.modal-title {
  font-size: 1.75rem;
  font-weight: 500;
  color: #3a3632;
  margin-bottom: 0.5rem;
  letter-spacing: 0.1rem;
}

.modal-subtitle {
  font-size: 1rem;
  color: #6b6560;
  font-weight: 300;
  margin-bottom: 1.5rem;
}

.modal-meta {
  display: flex;
  gap: 1.5rem;
  margin-bottom: 1.5rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid rgba(139, 115, 85, 0.2);
  font-size: 0.85rem;
  color: #6b6560;
}

.modal-description {
  font-size: 0.95rem;
  color: #3a3632;
  line-height: 2;
  margin-bottom: 2rem;
}

.read-link {
  display: inline-block;
  padding: 0.875rem 2.5rem;
  background: #8b7355;
  color: #f5f1e8;
  text-decoration: none;
  font-size: 0.9rem;
  letter-spacing: 0.2rem;
  transition: all 0.3s ease;
  font-weight: 400;
}

.read-link:hover {
  background: #6b5845;
  letter-spacing: 0.3rem;
}

.footer {
  background: #131316;
  backdrop-filter: blur(10px);
  border-top: 1px solid rgba(58, 54, 50, 0.1);
  padding: 2rem;
  text-align: center;
  color: #B8B8B8;
  font-size: 0.8rem;
  font-weight: 300;
  letter-spacing: 0.1rem;
}
.sub-item {
  padding: 12px 16px;
  background: #f9f9f9;
  border-radius: 8px;
  border: 1px solid #e5e5e5;

  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;

  transition: all 0.2s ease;

  @media (max-width: 768px) {
    flex-direction: column;
  }
}

@media (max-width: 768px) {
  .header h1 {
    font-size: 1.5rem;
  }

  .container {
    padding: 2rem 1rem;
  }

  .search-section {
    flex-direction: column;
  }

  .books-grid {
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
    gap: 1.5rem;
  }

  .modal-body {
    flex-direction: column;
    padding: 1.5rem;
  }

  .modal-cover {
    width: 100%;
    max-width: 240px;
    margin: 0 auto;
  }

  .modal-details {
    padding-top: 0;
  }

  .close-btn {
    top: 1rem;
    right: 1rem;
  }
}
/* 平板尺寸 (768px - 1024px) */
@media (max-width: 1024px) {
  .container {
    padding: 2.5rem 1.5rem;
  }

  .books-grid {
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    gap: 1.75rem;
  }

  .modal-content {
    max-width: 90%;
  }
}

/* 手機尺寸 (最大 768px) */
@media (max-width: 768px) {
  .header {
    padding: 2rem 1.5rem;

  }

  .header-content img {
    width: 70px;
  }

  .header h1 {
    letter-spacing: 0.2rem;
  }

  .subtitle {
    font-size: 0.75rem;
    letter-spacing: 0.15rem;
  }

  .container {
    padding: 2rem 1rem;
  }

  .controls {
    margin-bottom: 2rem;
  }

  .search-section {
    flex-direction: column;
    max-width: 100%;
  }

  .search-bar {
    padding: 0.75rem 1rem;
  }

  .search-bar input {
    font-size: 0.85rem;
  }

  .dropdown-btn {
    width: 100%;
    justify-content: space-between;
    padding: 0.75rem 1rem;
    font-size: 0.85rem;
  }

  .dropdown-menu {
    width: 100%;
    left: 0;
    right: 0;
  }

  .books-grid {
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
    gap: 1.5rem;
  }

  .book-title {
    font-size: 0.9rem;
  }

  .book-subtitle {
    font-size: 0.75rem;
  }

  .modal-overlay {
    padding: 1rem;
  }

  .modal-content {
    max-height: 85vh;
  }

  .modal-body {
    flex-direction: column;
    padding: 1.5rem;
    gap: 1.5rem;
  }

  .modal-cover {
    width: 100%;
    max-width: 240px;
    margin: 0 auto;
  }

  .modal-details {
    padding-top: 0;
  }

  .modal-title {
    font-size: 1.5rem;
  }

  .modal-subtitle {
    font-size: 0.9rem;
  }

  .modal-meta {
    flex-direction: column;
    gap: 0.5rem;
    font-size: 0.8rem;
  }

  .modal-description {
    font-size: 0.9rem;
    line-height: 1.8;
  }

  .read-link {
    padding: 0.75rem 2rem;
    font-size: 0.85rem;
    width: 100%;
    text-align: center;
  }

  .close-btn {
    top: 1rem;
    right: 0rem;
  }

  .footer {
    padding: 1.5rem 1rem;
    font-size: 0.7rem;
  }
}

/* 小型手機 (最大 480px) */
@media (max-width: 480px) {
  .header {
    padding: 1.5rem 1rem;
  }

  .header-content img {
    width: 60px;
  }

  .header h1 {

    letter-spacing: 0.15rem;
  }

  .container {
    padding: 1.5rem 0.75rem;
  }

  .books-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
  }

  .book-cover {
    margin-bottom: 0.75rem;
  }

  .book-title {
    font-size: 0.85rem;
  }

  .book-category {
    font-size: 0.7rem;
  }

  .modal-body {
    padding: 1rem;
  }

  .modal-title {
    font-size: 1.25rem;
  }

  .modal-category {
    font-size: 0.7rem;
  }

  .read-link {
    padding: 0.65rem 1.5rem;
    letter-spacing: 0.15rem;
  }

  .read-link:hover {
    letter-spacing: 0.2rem;
  }

  .footer {
    font-size: 0.65rem;
    line-height: 1.6;
  }
}

/* 極小螢幕 (最大 360px) */
@media (max-width: 360px) {
  .header-content img {
    width: 50px;
  }

  .books-grid {
    gap: 0.75rem;
  }

  .modal-cover {
    max-width: 200px;
  }

  .footer {
    padding: 1rem 0.5rem;
  }
}

/* 橫向模式優化 */
@media (max-height: 600px) and (orientation: landscape) {
  .header {
    padding: 1.5rem 1rem;
  }

  .modal-content {
    max-height: 95vh;
  }

  .modal-body {
    flex-direction: row;
    padding: 1.5rem;
  }

  .modal-cover {
    width: 180px;
    max-width: 180px;
  }
}
`;
document.head.appendChild(style);